/** Prefixes for `invalidateQueryPrefix` — keep aligned with domain key builders. */
export const QUERY_KEY_PREFIX = {
  orderDetails: "order-details|",
  /** Legacy Preview Billing keys (`use-billing-preview`). Kept until that path is removed. */
  billingPreview: "billing-preview|",
  /** Live pricing transport memo (`usePricingPreview` / `pricingPreviewQueryKey`). */
  pricingPreview: "pricing-preview|",
  discountsByRestaurant: "discounts|by-restaurant|",
  menuCatalog: "menu|catalog|",
  ordersByUser: "orders|by-user|",
  addressesByUser: "addresses|by-user|",
  checkoutSuccess: "checkout-success|",
  paymentResult: "payment-result|",
  restaurantConfig: "restaurant|config|",
  homepage: "homepage|",
} as const
